<header>
    <!-- <div class="top-header">
      <div class="container">
              <div class="row justify-content-between">
                <ul class="col-md-9 d-flex justify-content-start"> 
                  <li><a href="tel:07126617181"><i class="fa fa-phone" aria-hidden="true"></i> 07126617181</a></li>
                  <li><a href="tel:919307900682"><i class="fa fa-phone" aria-hidden="true"></i> 919307900682</a></li>                      
                  </ul>
                <ul class="col-md-3 d-flex justify-content-end">
              <li><a href="https://hobbyclubs.raisoni.net/" target="_blank" style="background: #f05423;
                padding: 6px;">Hobby Club</a></li>

                       
                    </ul>
              </div>
          </div>
    </div> -->
    <!-- <div class="top-name">
      <div class="container">
        <div class="row justify-content-between align-items-center">
          <div class="col-md-2 text-center">
            <a routerLink="/"><img src="assets/images/new-theme/logo.png" alt="Logo" title="logo" width="300px"></a>
          </div>
          <div class="col-md-8 text-center">
            <h2>G H RAISONI COLLEGE OF COMMERCE, SCIENCE<br> AND TECHNOLOGY, NAGPUR</h2>
            <h6>Accredited by NAAC 'A' Grade</h6>
          </div>
          <div class="col-md-2">
            <a href="https://raisoni.net/" target="_blank"><img src="assets/images/new-theme/rgi-logo.png" alt="Logo" title="logo" width="180px"></a>
          </div>
        </div>
      </div>
    </div> -->
      <app-header-navigation></app-header-navigation>          
  </header>
  
